import Vue from 'vue'
import Router from 'vue-router'
import { getToken, removeToken } from "../util/auth"

// import oauth from '../util/oauth'
const Home = () =>
    import ( /* webpackChunkName: "home" */ "@/views/Home/index.vue")

Vue.use(Router)


const router =  new Router({
    mode: 'history',
    base: '/auth/',
    routes: [{
            path: '/',
            component: Home
        },
        {
            path: '/login',
            component: () =>
                import ( /* webpackChunkName: "login" */ "@/views/Login/index.vue")
        },
        {
          path: '/register',
          component: () => import ( /* webpackChunkName: "register" */ "@/views/Register/index.vue")
        },
        {
          path: '/findPwd',
          component: () => import ( /* webpackChunkName: "register" */ "@/views/Cognition/FindPwd/index.vue")
        },
        {
          path: '/resetpwd',
          component: () => import ( /* webpackChunkName: "register" */ "@/views/Cognition/ResetPwd/index.vue")
        },
      {
        path: '/register/document',
        component: () => import ( /* webpackChunkName: "register" */ "@/views/Register/document")
      },
      {
        path: '/redirect',
        component: () => import ( "@/views/Redirect/index.vue")
       },
      {
            path: '/',
            component: () =>
                import ( /* webpackChunkName: "cognition" */ "@/views/Cognition/Layout.vue"),
            children: [{
                    path: 'signup',
                    component: () =>
                        import ( /* webpackChunkName: "signup" */ "@/views/Cognition/Register/index.vue")
                },
                {
                    path: 'resetpwd',
                    component: () =>
                        import ( /* webpackChunkName: "resetpwd" */ "@/views/Cognition/ResetPwd/index.vue")
                },
                {
                    path: 'updatepwd',
                    component: () =>
                        import ( /* webpackChunkName: "updatepwd" */ "@/views/Cognition/UpdatePwd/index.vue")
                },
                {
                    path: 'userCenter',
                    component: () =>
                        import ( /* webpackChunkName: "updatepwd" */ "@/views/Cognition/UserCenter/index.vue")
                },
                {
                    path: 'findpwd',
                    component: () =>
                        import ( /* webpackChunkName: "findpwd" */ "@/views/Cognition/FindPwd/index.vue")
                }
            ]
        },
        {
            path: '*',
            component: Home
        }
    ]
})

const whiteList = ['/login', '/register', '/register/document', '/signup','/findPwd', '/resetpwd'] //不需要判断登录的路由
const clearList = ['/resetpwd'] // 需要清空token访问的路由
router.beforeEach(async (to, from, next)=> {
  const accessToken = getToken();
  console.log('token-----',accessToken);
  if(accessToken) {
    if(clearList.includes(to.path)) {
      removeToken()
      next()
    } else if(whiteList.includes(to.path)) {
      console.log('路由token有效')
      console.log(to)
      if(to.path == '/login' && to.query.fromUrl) {
        location.href = to.query.fromUrl;
      }else{
        next({path:'/'})
      }
      // authVerify().then(()=>{
      //   if(to.path == '/login' && to.query.fromUrl) {
      //     location.href = to.query.fromUrl;
      //   }else{
      //     next({path:'/'})
      //   }
      // }).catch((err)=>{
      //   removeToken()
      //   console.log(err)
      //   // next({path:`/login?fromUrl=${to.query.fromUrl}`})
      // })
      // if(to.path == '/login' && to.query.fromUrl) {
      //   location.href = to.query.fromUrl;
      // }else{
      //   next({path:'/'})
      // }
    }else{
      next()
    }
  }else{
    console.log('路由token无效')
    if(whiteList.includes(to.path)) {
      next()
    }else{
      to.path === '/login' ? next() : next('/login')
      // ad域免登录不用
      // try {
      //   const auth = await oauth(false)
      //   auth ? next('/') : (to.path === '/login' ? next() : next('/login'))
      // } catch(err) {
      //   to.path === '/login' ? next() : next('/login')
      //   console.error(err)
      // }
    }
  }

})
export default router